<template>
  <div class="simple-container">
    <h1>Simple Page</h1>
    <p>This is a simple placeholder page.</p>
  </div>
</template>

<script>
export default {
  name: 'Simple'
}
</script>

<style scoped>
.simple-container {
  min-height: 80vh;
  padding: 4rem 2rem;
  text-align: center;
}
</style>
